import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress React 18 portal/hydration DOM errors
// These errors occur when modals close during navigation
// They are cosmetic and don't affect functionality
if (typeof window !== 'undefined') {
  // Store original methods
  const originalRemoveChild = Node.prototype.removeChild;
  const originalInsertBefore = Node.prototype.insertBefore;

  // Patch removeChild to handle detached nodes gracefully
  Node.prototype.removeChild = function(child) {
    if (!child || child.parentNode !== this) {
      // Node already removed or not a child - return silently
      return child;
    }
    return originalRemoveChild.call(this, child);
  };

  // Patch insertBefore to handle missing reference nodes
  Node.prototype.insertBefore = function(newNode, refNode) {
    if (refNode && refNode.parentNode !== this) {
      // Reference node is not a child - append instead
      return this.appendChild(newNode);
    }
    return originalInsertBefore.call(this, newNode, refNode);
  };

  // Also suppress the console errors for these specific React warnings
  const originalError = console.error;
  console.error = function(...args) {
    const message = args[0];
    if (typeof message === 'string') {
      // Suppress specific React DOM errors
      if (
        message.includes('removeChild') ||
        message.includes('insertBefore') ||
        message.includes('The node to be removed is not a child') ||
        message.includes('Failed to execute')
      ) {
        return; // Silently ignore
      }
    }
    return originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        console.log('SW registered:', reg.scope);
      })
      .catch((err) => {
        console.log('SW registration failed:', err);
      });
  });
}
